module.exports = __webpack_public_path__ + "static/media/Laureate.5ffd7a7b.jpeg";